import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgFlowerSpa = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M6.40399 8.89933C7.39861 9.5 8.26042 10.2951 8.93628 11.2353C9.14288 11.5225 9.33177 11.8243 9.5 12.1348C9.66823 11.8214 9.85712 11.5225 10.0637 11.2353C10.7396 10.2951 11.6014 9.5 12.596 8.89933C13.9153 8.10134 15.4648 7.64286 17.1146 7.64286H17.4068C17.7344 7.64286 18 7.90402 18 8.22612C18 12.5208 14.4613 16 10.0932 16H9.5H8.90677C4.53871 16 1 12.5208 1 8.22612C1 7.90402 1.26562 7.64286 1.59323 7.64286H1.88542C3.53524 7.64286 5.08472 8.10134 6.40399 8.89933ZM9.89844 3.1625C10.3618 3.6529 11.7017 5.24598 12.3894 7.93884C11.2679 8.56562 10.2821 9.41295 9.5 10.4228C8.71788 9.41295 7.73212 8.56853 6.61059 7.93884C7.29531 5.24598 8.63524 3.6529 9.10156 3.1625C9.20486 3.05513 9.34948 3 9.5 3C9.65052 3 9.79514 3.05513 9.89844 3.1625Z",
		fill: "#0D2976"
	})
});
export default SvgFlowerSpa;
